<mat-dialog-content class="app-wound-dialog__content">
    <div>
        <h2 mat-dialog-title class="app-wound-dialog__title">
            {{
                data.wound.id
                    ? ('apps.patient.overview.editWound' | translate)
                    : ('apps.patient.overview.addWound' | translate)
            }}
        </h2>
        <app-wound-form
            [formGroup]="woundForm"
            [isBedSideMode]="data.isBedSideMode"
            [isActive]="true"
        ></app-wound-form>
    </div>

    <div class="app-wound-dialog__actions">
        <button mat-button class="app-wound-dialog__cancel" color="primary" mat-dialog-close>
            {{ 'apps.patient.overview.dialogCancel' | translate }}
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="submitChange()">
            {{ 'apps.patient.overview.dialogSave' | translate }}
        </button>
    </div>
</mat-dialog-content>
